module.exports = __webpack_public_path__ + "static/media/59.47f46b26.jpg";